import { lazy } from 'react';

const LoadableReportMessageSpamModal = lazy(
  () => import(/* webpackChunkName: "damz-modals" */ './ReportMessageSpamModal')
);

export default LoadableReportMessageSpamModal;
